import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import { FormattedMessage } from 'react-intl';

import Modal from '../../components/Modal';
import ModalButtons from '../../components/ModalButtons';
import InvoicesList from '../../../components/Invoices/InvoicesList';
import { TextButton } from '../../../components/Buttons';
import Error from '../../../components/Error';
import { BffFetchContainer } from '../../../containers/FetchContainer';

import { actions as modalsActions } from '../../../redux/modals';
import { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import {
    INVOICE_DETAILS,
} from '../../types';
import ModalHeader from '../../components/ModalHeader';

const InvoicesModal = ({ showModal, onClose, theme, subscriptionId, i18n: { formatMessage } }) => {
    const dispatch = useDispatch();
    const endpoint = subscriptionId ? `/subscriptions/${subscriptionId}/invoices` : '/invoices';

    const renderError = onClickHandlers => (
        <div className={ theme.invoicesModalError }>
            <Error
                inline
                onClickHandlers={{
                    ...onClickHandlers,
                    cancel: onClose,
                }}
            />
        </div>
    );

    return (
        <Modal
            onClose={ onClose }
            theme={ theme }
            open={ showModal }
            className={ theme.dialog }
            classes={{ paper: theme.paper }}
            data-testid="invoices-modal"
        >
            <ModalHeader
                title={ formatMessage('modals.invoices.header') }
                className={ theme.header }
                onClose={ onClose }
            />
            <Divider classes={{ root: theme.divider }} />
            <div className={ theme.invoicesModal }>
                <BffFetchContainer endpoint={ endpoint } renderError={ renderError } theme={ theme }>
                    { data => (
                        <InvoicesList
                            invoices={ data }
                            theme={ theme }
                            onInvoiceClick={
                                invoiceNumber => dispatch(modalsActions.showModal(
                                    INVOICE_DETAILS, { invoiceNumber, subscriptionId }
                                ))
                            }
                        />
                    ) }
                </BffFetchContainer>
            </div>
            <Divider classes={{ root: theme.divider }} />
            <ModalButtons className={ theme.buttons }>
                <TextButton theme={ theme } onClick={ onClose }>
                    <FormattedMessage id="modals.invoices.buttons.close" />
                </TextButton>
            </ModalButtons>
        </Modal>
    );
};

InvoicesModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    theme: PropTypes.shape({}),
    intl: PropTypes.shape({}).isRequired,
    showModal: PropTypes.bool.isRequired,
    subscriptionId: PropTypes.string,
    i18n: i18nPropTypes,
};

export default InvoicesModal;
